import { loggerNamespace } from '../lib/Logger'
import { rpc } from '../lib/Rpc'
import { store } from '../store'
import { authService } from './AuthService'
import { IProfileGetProfile } from '../interfaces/rpc/IProfileGetProfile'
import { IBusinessGetProfileById } from '../interfaces/rpc/IBusinessGetProfileById'

class ProfileService {
  private logger = loggerNamespace('ProfileService')

  public loadProfile = async () => {
    const { error, result } = await rpc.call<IProfileGetProfile>('profile.get_profile', {
      id: authService.authData.userInfo?.user_id,
      with_business_info: true,
    })
    this.logger.info('profile.get_profile', { error, result })
    if (result) {
      store.profile.profile = result
      const businessId = Object.keys(result.businessData)[0]
      await this.setBusinessId(businessId)
    }
  }

  public setBusinessId = async (businessId: string) => {
    store.ui.loading = true
    store.profile.businessId = businessId
    await this.loadBusiness(businessId)
    store.ui.loading = false
  }

  private loadBusiness = async (businessId: string) => {
    if (store.profile.businessId) {
      const { error, result } = await rpc.call<IBusinessGetProfileById>('business.get_profile_by_id', {
        business: { id: store.profile.businessId },
        skip_worker_sorting: true,
      })
      this.logger.info('business.get_profile_by_id', { error, result })
      if (result) {
        store.profile.business = result
      }
    }
  }
}

const profileService = new ProfileService()
export { profileService }
